export default __webpack_public_path__ + "static/logo-point32.png?8dceec9ac153";